import React, { useState } from 'react';
import { IoAdd } from 'react-icons/io5';

export const AddIgnoredDomain = ({ onAdd }) => {
  const [domain, setDomain] = useState('');
  const [adding, setAdding] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();

    if (!domain.trim()) {
      setError('Domain is required');
      return;
    }

    setAdding(true);
    setError('');

    try {
      await onAdd(domain.trim());
      setDomain('');
    } catch (err) {
      setError(err.message || 'Failed to add domain');
    } finally {
      setAdding(false);
    }
  };

  return (
    <div className='add-ignored-domain-section'>
      <form onSubmit={handleSubmit} className='add-ignored-domain-form'>
        <div className='input-group'>
          <input
            type='text'
            value={domain}
            onChange={e => setDomain(e.target.value)}
            placeholder='example.com'
            className='ignored-domain-input'
            required
            disabled={adding}
          />
          <button type='submit' className='add-button' disabled={adding || !domain.trim()}>
            <IoAdd size={16} />
            {adding ? 'Adding...' : 'Add Domain'}
          </button>
        </div>

        {error && <div className='error-text'>{error}</div>}
      </form>
    </div>
  );
};
